<template>
  <div class="queue-sync-status" :class="state.updating ? 'updating' : state.status.toLowerCase()" role="status" aria-live="polite">
    <strong>{{ state.updating ? "Updating…" : state.status }}</strong>
    <span class="device-label"> · {{ deviceLabel }}</span>
    <span v-if="state.lastAppliedRevision >= 0"> · Revision {{ state.lastAppliedRevision }}</span>
    <span v-if="state.reason && !state.updating"> — {{ state.reason }}</span>
    <p v-if="state.notice" class="operation-notice">{{ state.notice }}</p>
  </div>
</template>

<script>
import { getBrowserIdentity } from "@/lib/deviceIdentity";
export default {
  props: { state: { type: Object, required: true } },
  data() { return { deviceLabel: getBrowserIdentity().label }; },
};
</script>

<style scoped>
.queue-sync-status { padding: 0.65rem 1rem; border-radius: 0.5rem; background: #fff4cc; color: #5c4300; font: 14px/1.4 system-ui, sans-serif; }
.operation-notice { margin: 0.35rem 0 0; }
.queue-sync-status.live { background: #dcfce7; color: #14532d; }
.queue-sync-status.updating { background: #f1f5f9; color: #475569; }
.queue-sync-status.offline { background: #fee2e2; color: #7f1d1d; }
</style>
